// CHARGES
import DetailCharge from "../pages/products/charges/DetailCharge";
import EditCharge from "../pages/products/charges/EditCharge";
import ManageCharge from "../pages/products/charges/ManageCharge";
import NewCharge from "../pages/products/charges/NewCharge";

// INTEREST RATE
import DetailInterestRate from "../pages/products/interestOrFloatingRate/DetailInterestRate";
import EditInterestRate from "../pages/products/interestOrFloatingRate/EditInterestRate";
import ManageInterestRate from "../pages/products/interestOrFloatingRate/ManageInterestRate";
import NewInterestRate from "../pages/products/interestOrFloatingRate/NewInterestRate";

// PRODUCT MIX
import DetailPRD0602 from "../pages/products/manageExchangeRate/fxRateSetup/DetailRateSetup";
import EditPRD0602 from "../pages/products/manageExchangeRate/fxRateSetup/EditRateSetup";
import ManagePRD0602 from "../pages/products/manageExchangeRate/fxRateSetup/ManageRateSetup";
import NewPRD0602 from "../pages/products/manageExchangeRate/fxRateSetup/NewRateSetup";
import DetailPRD0601 from "../pages/products/manageExchangeRate/fxRateTypeSetup/DetailRateType";
import EditPRD0601 from "../pages/products/manageExchangeRate/fxRateTypeSetup/EditRateType";
import ManagePRD0601 from "../pages/products/manageExchangeRate/fxRateTypeSetup/ManageRateType";
import NewPRD0601 from "../pages/products/manageExchangeRate/fxRateTypeSetup/NewRateType";
import DetailPRD1300 from "../pages/products/manageTax/taxComponents/DetailTaxComponent";
import EditPRD1300 from "../pages/products/manageTax/taxComponents/EditTaxComponent";
import ManagePRD1300 from "../pages/products/manageTax/taxComponents/ManageTax";
import NewPRD1300 from "../pages/products/manageTax/taxComponents/NewTaxComponent";
import DetailTaxGroup from "../pages/products/manageTax/taxGroups/DetailTaxGroup";
import EditTaxGroup from "../pages/products/manageTax/taxGroups/EditTaxGroup";
import PRD1301 from "../pages/products/manageTax/taxGroups/ManageTaxGroup";
import NewTaxGroup from "../pages/products/manageTax/taxGroups/NewTaxGroup";
import DetailProductMix from "../pages/products/productMix/DetailProductMix";
import EditProductMix from "../pages/products/productMix/EditProductMix";
import ManageProductMix from "../pages/products/productMix/ManageProductMix";
import NewProductMix from "../pages/products/productMix/NewProductMix";

//CASA IMPORTS
import ViewPRD0100 from "../pages/products/casa/DetailCasa";
import EditPRD0100 from "../pages/products/casa/EditCasa";
import PRD0100 from "../pages/products/casa/ManageCasa";
import AddPRD0100 from "../pages/products/casa/NewCasa";

//FIXED DEPOSIT IMPORTS
import EditPRD0300 from "../pages/products/FixedDeposits/editFixedDeposit/EditFixedDepositProduct";
import PRD0300 from "../pages/products/FixedDeposits/ManageFixedDeposit/ManageFixedDeposit";
import AddPRD0300 from "../pages/products/FixedDeposits/NewFixedDeposit/NewFixedDeposit";
import ViewPRD0300 from "../pages/products/FixedDeposits/viewFixedDeposit/viewFixedDeposit";

//RECURRING DEPOSIT IMPORTS
import ViewPRD0400 from "../pages/products/rede/DetailRecurringDeposit";
import EditPRD0400 from "../pages/products/rede/EditRecurringDeposit";
import PRD0400 from "../pages/products/rede/ManageRecurringDeposit";
import AddPRD0400 from "../pages/products/rede/NewRecurringDeposit";

//CALL DEPOSIT IMPORTS
import EditPRD0500 from "../pages/products/callDeposits/editCallDeposit/EditCallDepositProduct";
import PRD0500 from "../pages/products/callDeposits/ManageCallDeposit/ManageCallDeposit";
import AddPRD0500 from "../pages/products/callDeposits/NewCallDeposit/NewCallDeposit";
import ViewPRD0500 from "../pages/products/callDeposits/viewCallDeposit/viewCallDeposit";

//RETAIL LOAN IMPORTS
import ManageBond from "../pages/operations/moneyMarket/bond/ManageBond";
import ViewOnlyCharge from "../pages/products/charges/view/ViewOnlyCharge";
import ViewOnlyInterestRate from "../pages/products/interestOrFloatingRate/view/ViewOnlyInterestRate";
import ViewOnlyTaxComponent from "../pages/products/manageTax/taxComponents/view/ViewOnlyTaxComponent";
import ViewOnlyTaxGroup from "../pages/products/manageTax/taxGroups/view/ViewOnlyTaxGroup";
import EditPRD0200 from "../pages/products/RetailLoan/editLoanProduct/editLoanProduct";
import PRD0200 from "../pages/products/RetailLoan/ManageLoanProduct/ManageLoanProduct";
import AddPRD0200 from "../pages/products/RetailLoan/NewLoanProduct/NewLoanProduct";
import ViewPRD0200 from "../pages/products/RetailLoan/viewLoanProduct/viewLoanProduct";

//MONEY MARKET IMPORTS
// import PRD0607 from "../pages/products/moneyMarket/ManageMoneyMarket";
// import NewPRD0607 from "../pages/products/moneyMarket/NewMoneyMarket";

// FINANCIAL INSTRUMENT
import AddFInancialInstrument from "../pages/products/financialInstrument/AddFInancialInstrument";
import ManageSecurityInstruction from "../pages/products/financialInstrument/ManageFinancialInstructions";
import ViewSecurityInstrument from "../pages/products/financialInstrument/ViewSecurityInstrument";
import ManageSecurityProduct from "../pages/products/securityProduct/ManageSecurityProduct";
import ViewSecurityProduct from "../pages/products/securityProduct/ViewSecurityProduct";

// SECURITY PRODUCT
import AddSecurityProduct from "../pages/products/securityProduct/AddSecurityProduct";

import ManageCertificate from "../pages/products/certificateTemplate/ManageCertificate";
import AddCertificateTemplate from "../pages/products/certificateTemplate/NewCertificate";
import EditCertificateTemplate from "../pages/products/certificateTemplate/EditCertificate";
import ViewCertificate from "../pages/products/certificateTemplate/ViewCertificate";

export default [
  // CHARGES
  {
    path: "/prd1000",
    component: ManageCharge,
    isProtected: true,
  },
  {
    path: "/charge-detail",
    component: DetailCharge,
    isProtected: true,
  },
  {
    path: "/new-charge",
    component: NewCharge,
    isProtected: true,
  },
  {
    path: "/edit-charge",
    component: EditCharge,
    isProtected: true,
  },

  //INTEREST RATE
  {
    path: "/prd0605",
    component: ManageInterestRate,
    isProtected: true,
  },
  {
    path: "/new-interest-rate",
    component: NewInterestRate,
    isProtected: true,
  },
  {
    path: "/interest-rate-detail",
    component: DetailInterestRate,
    isProtected: true,
  },
  {
    path: "/edit-interest-rate",
    component: EditInterestRate,
    isProtected: true,
  },

  //FX RATE SETUP

  {
    path: "/prd0601",
    component: ManagePRD0601,
    isProtected: true,
  },
  {
    path: "/add-prd0601",
    component: NewPRD0601,
    isProtected: true,
  },
  {
    path: "/view-prd0601",
    component: DetailPRD0601,
    isProtected: true,
  },
  {
    path: "/edit-prd0601",
    component: EditPRD0601,
    isProtected: true,
  },

  // RATE TYPE SETUP

  {
    path: "/prd0602",
    component: ManagePRD0602,
    isProtected: true,
  },
  {
    path: "/add-prd0602",
    component: NewPRD0602,
    isProtected: true,
  },
  {
    path: "/view-prd0602",
    component: DetailPRD0602,
    isProtected: true,
  },
  {
    path: "/edit-prd0602",
    component: EditPRD0602,
    isProtected: true,
  },

  // MANAGE TAX COMPONENTS
  {
    path: "/prd1300",
    component: ManagePRD1300,
    isProtected: true,
  },
  {
    path: "/add-prd1300",
    component: NewPRD1300,
    isProtected: true,
  },
  {
    path: "/view-prd1300",
    component: DetailPRD1300,
    isProtected: true,
  },
  {
    path: "/edit-prd1300",
    component: EditPRD1300,
    isProtected: true,
  },

  //PRODUCT MIX
  {
    path: "/prd0606",
    component: ManageProductMix,
    isProtected: true,
  },
  {
    path: "/new-product-mix",
    component: NewProductMix,
    isProtected: true,
  },
  {
    path: "/product-mix-detail",
    component: DetailProductMix,
    isProtected: true,
  },
  {
    path: "/edit-product-mix",
    component: EditProductMix,
    isProtected: true,
  },

  //Tax Group
  {
    path: "/prd1301",
    component: PRD1301,
    isProtected: true,
  },
  {
    path: "/detail-tax-group",
    component: DetailTaxGroup,
    isProtected: true,
  },
  {
    path: "/new-tax-group",
    component: NewTaxGroup,
    isProtected: true,
  },
  {
    path: "/edit-tax-group",
    component: EditTaxGroup,
    isProtected: true,
  },

  //CASA
  {
    path: "/prd0100",
    component: PRD0100,
    isProtected: true,
  },
  {
    path: "/add-prd0100",
    component: AddPRD0100,
    isProtected: true,
  },
  {
    path: "/view-prd0100",
    component: ViewPRD0100,
    isProtected: true,
  },
  {
    path: "/edit-prd0100",
    component: EditPRD0100,
    isProtected: true,
  },

  //FIXED DEPOSIT
  {
    path: "/prd0300",
    component: PRD0300,
    isProtected: true,
  },
  {
    path: "/add-prd0300",
    component: AddPRD0300,
    isProtected: true,
  },
  {
    path: "/view-prd0300",
    component: ViewPRD0300,
    isProtected: true,
  },
  {
    path: "/edit-prd0300",
    component: EditPRD0300,
    isProtected: true,
  },

  //RECURRING DEPOSIT
  {
    path: "/prd0400",
    component: PRD0400,
    isProtected: true,
  },
  {
    path: "/add-prd0400",
    component: AddPRD0400,
    isProtected: true,
  },
  {
    path: "/view-prd0400",
    component: ViewPRD0400,
    isProtected: true,
  },
  {
    path: "/edit-prd0400",
    component: EditPRD0400,
    isProtected: true,
  },

  // CALL DEPOSIT
  {
    path: "/prd0500",
    component: PRD0500,
    isProtected: true,
  },
  {
    path: "/add-prd0500",
    component: AddPRD0500,
    isProtected: true,
  },
  {
    path: "/view-prd0500",
    component: ViewPRD0500,
    isProtected: true,
  },
  {
    path: "/edit-prd0500",
    component: EditPRD0500,
    isProtected: true,
  },

  //RETAIL LOAN
  {
    path: "/prd0200",
    component: PRD0200,
    isProtected: true,
  },
  {
    path: "/add-prd0200",
    component: AddPRD0200,
    isProtected: true,
  },
  {
    path: "/view-prd0200",
    component: ViewPRD0200,
    isProtected: true,
  },
  {
    path: "/edit-prd0200",
    component: EditPRD0200,
    isProtected: true,
  },

  // MONEY MARKET
  {
    path: "/operations-bond",
    component: ManageBond,
    isProtected: true,
  },

  //Financial Instrument
  {
    path: "/add-security-instrument",
    component: AddFInancialInstrument,
    isProtected: true,
  },
  {
    path: "/Security-instrument",
    component: ManageSecurityInstruction,
    isProtected: true,
  },
  {
    path: "/edit-security-instrument",
    component: AddFInancialInstrument,
    isProtected: true,
  },
  {
    path: "/view-security-instrument",
    component: ViewSecurityInstrument,
    isProtected: true,
  },

  // security Product

  {
    path: "/add-security-product",
    component: AddSecurityProduct,
    isProtected: true,
  },
  {
    path: "/edit-security-product",
    component: AddSecurityProduct,
    isProtected: true,
  },
  {
    path: "/security-product",
    component: ManageSecurityProduct,
    isProtected: true,
  },

  {
    path: "/view-security-product",
    component: ViewSecurityProduct,
    isProtected: true,
  },

  // security Product

  {
    path: "/add-certificate-template",
    component: AddCertificateTemplate,
    isProtected: true,
  },
  {
    path: "/edit-certificate-template",
    component: EditCertificateTemplate,
    isProtected: true,
  },
  {
    path: "/certificate-template",
    component: ManageCertificate,
    isProtected: true,
  },

  {
    path: "/view-certificate-template",
    component: ViewCertificate,
    isProtected: true,
  },

  //View-only-screens
  {
    path: "/view-charge",
    component: ViewOnlyCharge,
    isProtected: true,
  },
  {
    path: "/view-interest-rate",
    component: ViewOnlyInterestRate,
    isProtected: true,
  },
  {
    path: "/view-tax-setup",
    component: ViewOnlyTaxComponent,
    isProtected: true,
  },
  {
    path: "/view-tax-group",
    component: ViewOnlyTaxGroup,
    isProtected: true,
  },
];
